import { Component, OnInit, Input } from '@angular/core';
import { Colegio } from 'src/app/interfaces/colegio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColegiosService } from 'src/app/services/colegios.service';
import { UserService } from 'src/app/services/user.service';

import * as moment from 'moment-timezone';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  @Input() nombres: string;
  @Input() apellidos: string;
  @Input() colegio: Colegio;
  @Input() genero: string;
  @Input() id: string;
  @Input() rol: string;

  avatar: any = 'assets/img/logocolor.png';

  loading = false;

  constructor(
    private userService: UserService,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    console.log('id header', this.id);
  }

  // irMagisterio() {
  //   this.loading = true;
  //   const tiempoMagisterio = moment().tz('Europe/Madrid').toDate();
  //   // Convertir a Timestamp si usas Firestore
  //   // @ts-ignore
  //   console.log('tiempoMagisterio', tiempoMagisterio);

  //   console.log('id', this.id);

  //   if (!this.id) {
  //     this.loading = false;
  //     alert(
  //       'Error al intentar ingresar en la página. Por favor, inténtalo de nuevo más tarde.'
  //     );
  //     return;
  //   }

  //   const codigoMagisterio = Array.from({ length: 16 }, () =>
  //     Math.random().toString(36).charAt(2)
  //   )
  //     .join('')
  //     .toUpperCase();
  //   console.log('codigoMagisterio', codigoMagisterio);

  //   // const magisterioInfo = {
  //   //   tiempoMagisterio: tiempoMagisterio,
  //   //   codigoMagisterio: codigoMagisterio,
  //   // };

  //   this.userService
  //     .editUser({ tiempoMagisterio, codigoMagisterio }, this.id)
  //     .then(() => {
  //       this.http
  //         .get<any>(
  //           'https://us-central1-thecampus-colegios.cloudfunctions.net/app/tokenMagisnet',
  //           { params: new HttpParams().set('codigo', codigoMagisterio) }
  //         )
  //         .subscribe((data) => {
  //           this.loading = false;
  //           if (data == 'error') {
  //             alert(
  //               'Error al intentar ingresar en la página. Por favor, inténtalo de nuevo más tarde.'
  //             );
  //             return;
  //           }
  //           console.log('token', data);
  //           const token = data;
  //           window.open(
  //             `https://www.magisnet.com/wp-json/magisnet-sso-for-the-campus/v1/login?token=${token}`
  //           );
  //         });
  //     });
  // }
}